import { useTranslation } from "react-i18next";
import { Flex, Grid, Paper, Skeleton, Text, Title } from "@mantine/core";
import { RatingBarChart } from "@testuj.to/react";

import { usePopularityMeasuring } from "../../../../hooks/overview";

export const PopularityMeasuringsWidget = () => {
    const { t } = useTranslation(["common"]);
    const { fourStars, oneStars, threeStars, twoStars, fiveStarts } = usePopularityMeasuring();
    const ratingBarChartItems = [
        { value: fiveStarts, label: "5" },
        { value: fourStars, label: "4" },
        { value: threeStars, label: "3" },
        { value: twoStars, label: "2" },
        { value: oneStars, label: "1" },
    ];
    return (
        <Flex direction="column">
            <Flex
                align="center"
                justify="space-between"
                mt="xl"
                mb="md"
                style={{ borderBottom: "1px solid transparent" }}
            >
                <Title order={3} size={16} style={{ fontWeight: 600 }}>
                    {t("dashboard_popularity_measuring")}
                </Title>
            </Flex>
            <Grid>
                <Grid.Col span={12} md={6}>
                    <Paper p={28} radius={12}></Paper>
                </Grid.Col>
                <Grid.Col span={12} md={6}>
                    <Paper p={28} radius={12}>
                        <Text mb={24} weight={600}>
                            {t("dashboard_popularity_measuring_rating")}
                        </Text>
                        <RatingBarChart items={ratingBarChartItems} />
                    </Paper>
                </Grid.Col>
            </Grid>
        </Flex>
    );
};
